// Session BCE: an engineer has no password, so their email and mobile are both REQUIRED. The emailed sign-in code goes
// to the email, and the office reaches them on the mobile. These checks mirror the server's (the server is the
// authority and answers 400 invalid_request with details.email / details.mobile); they exist so the office is told
// before the round trip, in plain words.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// A UK mobile: 07 followed by nine digits, or the same with +44 / 44 in place of the leading 0.
const UK_MOBILE_RE = /^(?:0|\+?44)7\d{9}$/;

export function engineerEmailProblem(value: string): string | null {
  const v = value.trim();
  if (!v) return "Enter an email address. The engineer signs in with a code sent to it.";
  if (!EMAIL_RE.test(v)) return "Enter a valid email address.";
  return null;
}

export function engineerMobileProblem(value: string): string | null {
  const v = value.trim();
  if (!v) return "Enter a mobile number.";
  const digits = v.replace(/[\s()-]/g, "");
  if (!UK_MOBILE_RE.test(digits)) return "Enter a UK mobile number, such as 07700 900123.";
  return null;
}

// True when an engineer cannot sign in yet because the email or the mobile is missing.
export function engineerNeedsDetails(e: { email: string | null; mobile: string | null }): boolean {
  return !(e.email ?? "").trim() || !(e.mobile ?? "").trim();
}

// Session BCK (D-BCK-1): engineers of ONE subcontractor may share an email address; everyone else needs their own.
export const EMAIL_TAKEN_MESSAGE =
  "That email address is already used by another account. Engineers can share one address only when both are linked to the same subcontractor.";

// The office note for an engineer who signs in by an address another engineer of their subcontractor also holds.
export function sharesEmailNote(names: string[] | undefined): string | null {
  const list = (names ?? []).filter((n) => n.trim());
  if (list.length === 0) return null;
  return `Shares this email with ${list.length === 1 ? list[0] : `${list.slice(0, -1).join(", ")} and ${list[list.length - 1]}`}`;
}

export const ENGINEER_NEEDS_DETAILS_NOTE = "Needs an email and a mobile number. Without an email they cannot sign in";
